import React from "react";

const WritingAbilityIcon = (props) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="37"
      height="37"
      rx="18.5"
      fill="none"
    />
    <g clipPath="url(#clip0_4466_7048)">
      <path
        d="M16.4283 25.737L10.6426 27.357L12.2626 21.5713L22.8569 11.0284C22.9766 10.906 23.1197 10.8087 23.2774 10.7423C23.4353 10.6758 23.6049 10.6416 23.7761 10.6416C23.9474 10.6416 24.117 10.6758 24.2749 10.7423C24.4326 10.8087 24.5757 10.906 24.6954 11.0284L26.9711 13.317C27.0916 13.4365 27.1873 13.5787 27.2526 13.7354C27.3179 13.8921 27.3515 14.0601 27.3515 14.2299C27.3515 14.3996 27.3179 14.5677 27.2526 14.7243C27.1873 14.881 27.0916 15.0232 26.9711 15.1427L16.4283 25.737Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4466_7048">
        <rect width="18" height="18" fill="white" transform="translate(10 10)" />
      </clipPath>
    </defs>
  </svg>
);

export default WritingAbilityIcon;